import React, { useState, useEffect } from "react";
import { Card, CircularProgress, Divider } from "@mui/material";
import NoDraft from "./NoDrafts";
import DraftList from "./List";
import FaiBox from "../../../MuiComponents/FaiBox";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import FaiButton from "../../../MuiComponents/FaiButton";
import AddIcon from "@mui/icons-material/Add";
import theme from "../../../assets/theme";

const Drafts: React.FC = () => {
	const { palette, typography, borders } = theme;
	// In a real application, this would fetch drafts from an API
	const [drafts, setDrafts] = useState([1, 2, 3]);
	const [loading, setLoading] = useState(true);

	const handleAddProduct = () => {
		// Navigate to add product page
		window.location.href = "/app/catalog/add-product";
	};

	useEffect(() => {
		// Simulate API call to fetch drafts
		setLoading(true);
		// Mock API call
		const fetchDrafts = setTimeout(() => {
			setLoading(false);
		}, 800);

		return () => clearTimeout(fetchDrafts);
	}, []);

	return (
		<FaiBox>
			<Card
				sx={{
					borderRadius: borders.borderRadius.lg,
					boxShadow: "0 4px 20px 0 rgba(0,0,0,0.1)",
					overflow: "visible"
				}}
			>
				<FaiBox 
					p={3} 
					display="flex" 
					alignItems="center" 
					justifyContent="space-between"
				>
					<FaiBox>
						<FaiTypography variant="h5" fontWeight={typography.fontWeightBold} color="dark">
							Draft Listings
						</FaiTypography>
						<FaiTypography variant="body2" color="text">
							Manage your product drafts before submitting for approval
						</FaiTypography>
					</FaiBox>
					
					<FaiButton
						variant="contained"
						color="primary"
						startIcon={<AddIcon />}
						onClick={handleAddProduct}
						sx={{ 
							boxShadow: "0 4px 14px 0 rgba(0,171,85,0.4)",
							"&:hover": {
								boxShadow: "0 6px 18px 0 rgba(0,171,85,0.5)"
							}
						}}
					>
						Add Product
					</FaiButton>
				</FaiBox>
				
				<Divider />
				
				{loading ? (
					<FaiBox 
						display="flex" 
						justifyContent="center" 
						alignItems="center" 
						height="400px"
					>
						<CircularProgress color="primary" />
					</FaiBox>
				) : !drafts.length ? (
					<NoDraft />
				) : (
					<FaiBox p={3}>
						<DraftList />
					</FaiBox>
				)}
			</Card>
		</FaiBox>
	);
};

export default Drafts;
